<!-- lendPeak.bills.component.html -->
<!-- Bills Tab Content -->
<div class="grid" *ngIf="lendPeak">
  <div class="col-12">
    <p-card>
      <p-toolbar styleClass="mb-4 gap-2">
        <ng-template pTemplate="left">
          <p-button
            label="Go to Last Due Bill"
            icon="pi pi-arrow-down"
            (click)="scrollToLastDueBill()"
            pTooltip="Scroll to the last due (unpaid) bill and highlight it"
          ></p-button>
        </ng-template>
      </p-toolbar>

      <p-table
        *ngIf="lendPeak.bills"
        [value]="lendPeak.bills.all"
        sortField="jsDueDate"
        [scrollable]="true"
        scrollHeight="600px"
      >
        <ng-template #header>
          <tr>
            <th pSortableColumn="id">
              Bill ID
              <p-sortIcon field="id"></p-sortIcon>
            </th>
            <th pSortableColumn="period">
              Period
              <p-sortIcon field="period"></p-sortIcon>
            </th>
            <th pSortableColumn="jsDueDate">
              Due Date
              <p-sortIcon field="jsDueDate"></p-sortIcon>
              f
            </th>
            <th>Principal Due</th>
            <th>Interest Due</th>
            <th>Fees Due</th>
            <th>Total Due</th>
            <th>Satisfied On</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </ng-template>

        <ng-template #body let-bill let-rowIndex="rowIndex">
          <tr #billRow [class.selected-row]="isBillHighlighted(bill)">
            <td>
              {{ bill.id }}

              <!-- Show a tag if there is more than 1 payment for this bill -->
              <p-tag
                *ngIf="bill.paymentDetails?.length > 1"
                value="{{ bill.paymentDetails.length + ' Payments' }}"
                severity="warn"
                styleClass="ml-2"
                pTooltip="This bill was satisfied by multiple payments"
                tooltipPosition="top"
              ></p-tag>
            </td>
            <td>{{ bill.period }}</td>
            <td>
              <p-tag
                value="{{ bill.amortizationEntry.jsPrebillDaysConfiguration }}"
                pTooltip="Days before period's end when the bill is due {{ bill.jsOpenDate | date: 'YYYY-MM-DD' }}"
                tooltipPosition="top"
                severity="secondary"
                styleClass="ml-2"
                size="large"
              ></p-tag>

              <i class="pi pi-arrows-h mr-2 ml-2"></i>

              <p-tag
                value="{{ bill.amortizationEntry.jsBillDueDaysAfterPeriodEndConfiguration }}"
                pTooltip="Days after period's end when the bill is due {{ bill.jsDueDate | date: 'YYYY-MM-DD' }}"
                tooltipPosition="top"
                severity="secondary"
                styleClass="mr-2"
              ></p-tag>
              {{ bill.jsDueDate | date: 'yyyy-MM-dd' }}
            </td>

            <td>
              <ng-container *ngIf="showMathInTheTable">
                {{ bill.jsOriginalPrincipalDue | currency }}
                -
                {{ bill.jsAllocatedPrincipalSum | currency }}
                =
              </ng-container>
              <ng-container *ngIf="!showMathInTheTable && bill.jsOriginalPrincipalDue != bill.jsPrincipalDue">
                {{ bill.jsOriginalPrincipalDue | currency }}
                <i class="pi pi-arrow-right" style="font-size: 0.7rem"></i>
              </ng-container>
              <span [class.font-semibold]="bill.jsPrincipalDue > 0">
                {{ bill.jsPrincipalDue | currency }}
              </span>
            </td>
            <td>
              <ng-container *ngIf="showMathInTheTable">
                {{ bill.jsOriginalInterestDue | currency }}
                -
                {{ bill.jsAllocatedInterestSum | currency }}
                =
              </ng-container>
              <ng-container *ngIf="!showMathInTheTable && bill.jsOriginalInterestDue != bill.jsInterestDue">
                {{ bill.jsOriginalInterestDue | currency }}
                <i class="pi pi-arrow-right" style="font-size: 0.7rem"></i>
              </ng-container>
              <span [class.font-semibold]="bill.jsInterestDue > 0">
                {{ bill.jsInterestDue | currency }}
              </span>
            </td>
            <td>
              <ng-container *ngIf="showMathInTheTable">
                {{ bill.jsOriginalFeesDue | currency }}
                -
                {{ bill.jsAllocatedFeesSum | currency }}
                =
              </ng-container>
              <ng-container *ngIf="!showMathInTheTable && bill.jsFeesDue != bill.jsOriginalFeesDue">
                {{ bill.jsFeesDue | currency }}
                <i class="pi pi-arrow-right" style="font-size: 0.7rem"></i>
              </ng-container>
              <span [class.font-semibold]="bill.jsFeesDue > 0">
                {{ bill.jsFeesDue | currency }}
              </span>
            </td>
            <td>
              <ng-container *ngIf="showMathInTheTable">
                {{ bill.jsOriginalTotalDue | currency }}
                -
                {{ bill.jsAllocatedTotalSum | currency }}
                =
              </ng-container>
              <ng-container *ngIf="!showMathInTheTable && bill.jsTotalDue != bill.jsOriginalTotalDue">
                {{ bill.jsOriginalTotalDue | currency }}
                <i class="pi pi-arrow-right" style="font-size: 0.7rem"></i>
              </ng-container>
              <span [class.font-semibold]="bill.jsTotalDue > 0">
                {{ bill.jsTotalDue | currency }}
              </span>
            </td>
            <td>
              <!-- Only show if the bill is paid and we have a satisfied date -->
              <ng-container *ngIf="bill.isPaid() && bill.dateFullySatisfied">
                <!-- Display date satisfied -->
                <span class="mr-3">{{ bill.jsDateFullySatisfied | date: 'yyyy-MM-dd' }}</span>

                <!-- Show how many days late/early in a p-tag -->
                <ng-container *ngIf="bill.daysLate > 0">
                  <p-tag value="{{ bill.daysLate + ' Days Late' }}" severity="warn" class="status-tag"></p-tag>
                </ng-container>

                <ng-container *ngIf="bill.daysEarly > 0">
                  <p-tag value="{{ bill.daysEarly + ' Days Early' }}" severity="success" class="status-tag"></p-tag>
                </ng-container>

                <!-- If daysLate = 0 & daysEarly = 0, then it's on-time -->
                <ng-container *ngIf="!bill.daysLate && !bill.daysEarly">
                  <p-tag value="On-Time" severity="info" class="status-tag"></p-tag>
                </ng-container>
              </ng-container>
            </td>

            <td>
              <!-- Existing Status Tags -->
              <p-tag
                *ngIf="bill.isOpen(snapshotDate) && !bill.isPaid()"
                value="Open Bill"
                severity="success"
                class="status-tag"
              ></p-tag>
              <p-tag
                *ngIf="!bill.isOpen(snapshotDate) && !bill.isPaid()"
                value="Future"
                severity="info"
                class="status-tag"
              ></p-tag>
              <!-- <p-tag
                *ngIf="bill.originalTotalDue.isZero()"
                value="Skip A Pay"
                severity="secondary"
                class="status-tag"
              ></p-tag> -->
              <p-tag
                *ngIf="bill.isOpen(snapshotDate)"
                value="{{ bill.isPaid() ? 'Paid' : 'Unpaid' }}"
                [severity]="bill.isPaid() ? 'success' : 'warn'"
                class="status-tag"
              ></p-tag>
              <p-tag
                *ngIf="bill.isPastDue(snapshotDate) && !bill.isPaid()"
                value="{{ bill.getDaysPastDue(snapshotDate) }} Days Past Due"
                severity="danger"
                class="status-tag"
              ></p-tag>
            </td>

            <td>
              <p-button
                icon="pi pi-eye"
                severity="info"
                styleClass="p-button-lg p-button-text"
                (click)="viewPaymentDetails(bill)"
                pTooltip="View Payment Details"
              ></p-button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  </div>
</div>

<!-- Payment Details Dialog -->
<p-dialog
  [(visible)]="showPaymentDetailsDialog"
  [modal]="true"
  [style]="{ width: '70%' }"
  [closable]="true"
  (onHide)="onPaymentDetailsDialogHide()"
>
  <ng-template #header>
    <div *ngIf="selectedBill" class="inline-flex items-center justify-center">
      <span class="font-semibold whitespace-nowrap pr-5">Payment Details for {{ selectedBill.id }}</span>
      <p-tag
        *ngIf="(selectedBill.paymentDetails || []).length > 1"
        value="{{ selectedBill.paymentDetails.length + ' Payments' }}"
        severity="warn"
        styleClass="ml-2 mr-2"
        pTooltip="This bill was satisfied by multiple payments"
        tooltipPosition="top"
      ></p-tag>

      <ng-container *ngIf="selectedBill.isPaid() && selectedBill.dateFullySatisfied">
        <!-- Show how many days late/early in a p-tag -->
        <ng-container *ngIf="selectedBill.daysLate">
          <p-tag value="{{ selectedBill.daysLate + ' Days Late' }}" severity="warn" class="status-tag"></p-tag>
        </ng-container>

        <ng-container *ngIf="selectedBill.daysEarly">
          <p-tag value="{{ selectedBill.daysEarly + ' Days Early' }}" severity="success" class="status-tag"></p-tag>
        </ng-container>

        <!-- If daysLate = 0 & daysEarly = 0, then it's on-time -->
        <ng-container *ngIf="!selectedBill.daysLate && !selectedBill.daysEarly">
          <p-tag value="On-Time" severity="info" class="status-tag"></p-tag>
        </ng-container>
      </ng-container>

      <!-- Existing Status Tags -->
      <p-tag
        *ngIf="selectedBill.isOpen(snapshotDate) && !selectedBill.isPaid()"
        value="Open Bill"
        severity="success"
        class="status-tag"
      ></p-tag>
      <p-tag
        *ngIf="!selectedBill.isOpen(snapshotDate) && !selectedBill.isPaid()"
        value="Future"
        severity="info"
        class="status-tag"
      ></p-tag>
      <p-tag *ngIf="selectedBill.jsTotalDue == 0" value="Skip A Pay" severity="secondary" class="status-tag"></p-tag>
      <p-tag
        *ngIf="selectedBill.jsOriginalTotalDue > 0"
        value="{{ selectedBill.isPaid() ? 'Paid' : 'Unpaid' }}"
        [severity]="selectedBill.isPaid() ? 'success' : 'warn'"
        class="status-tag"
      ></p-tag>
      <p-tag
        *ngIf="selectedBill.isPastDue(snapshotDate)"
        value="{{ selectedBill.getDaysPastDue(snapshotDate) }} Days Past Due"
        severity="danger"
        class="status-tag"
      ></p-tag>
    </div>
  </ng-template>
  <p-table [value]="selectedBill?.paymentDetails || []">
    <ng-template #header>
      <tr>
        <th>Deposit ID</th>
        <th>Deposit Amount</th>
        <th>Date</th>
        <th>Allocated Total</th>
        <th>Allocated Principal</th>
        <th>Allocated Interest</th>
        <th>Allocated Fees</th>
      </tr>

      <!-- Original row: how much was allocated in total -->
      <tr>
        <th class="bg-blue-50"></th>
        <th class="bg-blue-50"></th>
        <th class="bg-blue-50 text-right">Original Bill:</th>
        <th class="bg-blue-50" style="font-weight: bold">
          {{ selectedBill?.jsOriginalTotalDue | currency }}
        </th>
        <th class="bg-blue-50" style="font-weight: bold">
          {{ selectedBill?.jsOriginalPrincipalDue | currency }}
        </th>
        <th class="bg-blue-50" style="font-weight: bold">
          {{ selectedBill?.jsOriginalInterestDue | currency }}
        </th>
        <th class="bg-blue-50" style="font-weight: bold">
          {{ selectedBill?.jsOriginalFeesDue | currency }}
        </th>
      </tr>
    </ng-template>

    <ng-template #body let-detail *ngIf="lendPeak">
      <tr>
        <td style="white-space: nowrap">
          <p-button
            (click)="viewSinglePaymentDetail(detail)"
            icon="pi pi-search"
            [rounded]="true"
            [text]="true"
            severity="success"
            class="pr-2"
          />

          {{ detail.depositId }}

          <p-badge *ngIf="isSplitPayment(detail.depositId)" value="Split" severity="warn" styleClass="ml-2"></p-badge>
          <p-badge
            *ngIf="lendPeak.depositRecords.getById(detail.depositId)?.staticAllocation"
            value="Static"
            severity="info"
            styleClass="ml-2"
          ></p-badge>
        </td>
        <td>
          {{ lendPeak.depositRecords.getById(detail.depositId)?.jsAmount | currency }}
        </td>
        <td>{{ detail.jsDate | date: 'yyyy-MM-dd' }}</td>
        <td>{{ detail.jsAllocatedTotal | currency }}</td>
        <td>{{ detail.jsAllocatedPrincipal | currency }}</td>
        <td>{{ detail.jsAllocatedInterest | currency }}</td>
        <td>{{ detail.jsAllocatedFees | currency }}</td>
      </tr>
    </ng-template>

    <ng-template #footer>
      <!-- Totals row: how much was allocated in total -->
      <tr>
        <td class="bg-blue-50" colspan="3" style="text-align: right; font-weight: bold">Allocated:</td>
        <td class="bg-blue-50" style="font-weight: bold">
          {{ selectedBill?.jsAllocatedTotalSum | currency }}
        </td>
        <td class="bg-blue-50" style="font-weight: bold">
          {{ selectedBill?.jsAllocatedPrincipalSum | currency }}
        </td>
        <td class="bg-blue-50" style="font-weight: bold">
          {{ selectedBill?.jsAllocatedInterestSum | currency }}
        </td>
        <td class="bg-blue-50" style="font-weight: bold">
          {{ selectedBill?.jsAllocatedFeesSum | currency }}
        </td>
      </tr>

      <!-- Remaining row: original minus allocated -->
      <tr>
        <td class="bg-blue-50" colspan="3" style="text-align: right; font-weight: bold">Remaining:</td>
        <td class="bg-blue-50" style="font-weight: bold">
          {{ selectedBill?.jsRemainingTotal | currency }}
        </td>
        <td class="bg-blue-50" style="font-weight: bold">
          {{ selectedBill?.jsRemainingPrincipal | currency }}
        </td>
        <td class="bg-blue-50" style="font-weight: bold">
          {{ selectedBill?.jsRemainingInterest | currency }}
        </td>
        <td class="bg-blue-50" style="font-weight: bold">
          {{ selectedBill?.jsRemainingFees | currency }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-dialog>

<!-- Single Payment/Deposit Display Dialog (Non-blocking and Draggable) -->
<p-dialog
  *ngIf="lendPeak"
  [(visible)]="showSinglePaymentDialog"
  [modal]="false"
  [draggable]="true"
  [resizable]="true"
  [style]="{ width: '750px' }"
  (onHide)="selectedPaymentDeposit = null"
>
  <ng-template #header>
    <div class="inline-flex items-center justify-center">
      <span class="font-semibold whitespace-nowrap">Payment Card {{ selectedPaymentDeposit?.id }}</span>
      <p-badge
        *ngIf="(selectedPaymentDeposit?.usageDetails?.length || 0) > 1"
        class="ml-1"
        value="Split"
        severity="warn"
      ></p-badge>
      <p-badge
        *ngIf="selectedPaymentDeposit?.staticAllocation"
        value="Static"
        severity="info"
        styleClass="ml-2"
      ></p-badge>
    </div>
  </ng-template>
  <!-- Only show content if we have a selectedPaymentDeposit -->
  <ng-container *ngIf="selectedPaymentDeposit as deposit">
    <p-card [title]="'Payment ID: ' + deposit.id">
      <!-- Row 1: Amount, Unused, Currency -->
      <div class="grid text-sm">
        <div class="col-12 md:col-4 flex align-items-center">
          <span class="font-semibold text-300 mr-1">Amount:</span>
          <span>{{ deposit.jsAmount | currency }}</span>
        </div>
        <div class="col-12 md:col-4 flex align-items-center">
          <span class="font-semibold text-300 mr-1">Unused:</span>
          <span>{{ deposit.unusedAmount.toNumber() | currency }}</span>
        </div>
        <div class="col-12 md:col-3 flex align-items-center">
          <span class="font-semibold text-300 mr-1">Currency:</span>
          <span>{{ deposit.currency }}</span>
        </div>
      </div>

      <!-- Row 2: Effective Date, Clearing Date, Excess Applied -->
      <div class="grid text-sm gap-2 mt-2">
        <div class="col-12 md:col-4 flex align-items-center">
          <span class="font-semibold text-300 mr-1">Effective Date:</span>
          <span>{{ deposit.jsEffectiveDate | date: 'yyyy-MM-dd' }}</span>
        </div>
        <div class="col-12 md:col-4 flex align-items-center">
          <span class="font-semibold text-300 mr-1">Clearing Date:</span>
          <span>{{ deposit.jsClearingDate | date: 'yyyy-MM-dd' }}</span>
        </div>
        <div class="col-12 md:col-3 flex align-items-center">
          <span class="font-semibold text-300 mr-1">Excess Applied:</span>
          <span>{{ deposit.jsExcessAppliedDate | date: 'yyyy-MM-dd' }}</span>
        </div>
      </div>

      <!-- Row 3: Apply Excess to Principal, Allocation Type -->
      <div class="grid text-sm gap-2 mt-2">
        <div class="col-12 md:col-6 flex align-items-center">
          <span class="font-semibold text-300 mr-1">Apply Excess to Principal:</span>
          <span>{{ deposit.applyExcessToPrincipal ? 'Yes' : 'No' }}</span>
        </div>
        <div class="col-12 md:col-5 flex align-items-center">
          <span class="font-semibold text-300 mr-1">Allocation Type:</span>
          <span>{{ deposit.staticAllocation ? 'Static' : 'Default' }}</span>
        </div>
      </div>

      <!-- Row 4: Static Allocation (if present) -->
      <ng-container *ngIf="deposit.staticAllocation">
        <hr class="my-2" />
        <div *ngIf="deposit.staticAllocation" class="grid text-sm gap-2">
          <div class="col-12 md:col-3 flex align-items-center">
            <span class="font-semibold text-300 mr-1">Principal:</span>
            <span>{{ deposit.staticAllocation.jsPrincipal | currency }}</span>
          </div>
          <div class="col-12 md:col-3 flex align-items-center">
            <span class="font-semibold text-300 mr-1">Interest:</span>
            <span>{{ deposit.staticAllocation.jsInterest | currency }}</span>
          </div>
          <div class="col-12 md:col-3 flex align-items-center">
            <span class="font-semibold text-300 mr-1">Fees:</span>
            <span>{{ deposit.staticAllocation.jsFees | currency }}</span>
          </div>
          <div class="col-12 md:col-2 flex align-items-center">
            <span class="font-semibold text-300 mr-1">Prepayment:</span>
            <span>{{ deposit.staticAllocation.jsPrepayment | currency }}</span>
          </div>
        </div>
      </ng-container>
    </p-card>

    <!-- Usage Details Table -->
    <div class="text-sm mt-2">
      <span class="font-semibold text-300">Usage Details:</span>
      <p-table [value]="deposit.usageDetails || []" responsiveLayout="scroll" styleClass="mt-2">
        <ng-template pTemplate="header">
          <tr>
            <th>Period</th>
            <th>Bill ID</th>
            <th>Bill Due Date</th>
            <th>Allocated Principal</th>
            <th>Allocated Interest</th>
            <th>Allocated Fees</th>
            <th>Date</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-usage>
          <tr>
            <td>{{ usage.period }}</td>
            <td>{{ usage.billId }}</td>
            <td>
              {{ lendPeak.bills.getBillById(usage.billId)?.jsDueDate | date }}
            </td>
            <td>{{ usage.allocatedPrincipal.toNumber() | currency }}</td>
            <td>{{ usage.allocatedInterest.toNumber() | currency }}</td>
            <td>{{ usage.allocatedFees.toNumber() | currency }}</td>
            <td>{{ usage.date.toString() | date: 'yyyy-MM-dd' }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </ng-container>
</p-dialog>
